import type * as React from 'react';
import { AttentionList, EmptyState } from '@redhand/ui';
import { demoAttention } from '../demo-data.js';
import { PageIntro, StateSection } from '../ui-helpers.js';

const severityLabels = { info: 'Info', warning: 'Pozor', critical: 'Kritické' } as const;

export function AttentionListPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="AttentionList"
        lead="Co hoří: položka + závažnost + akce. Deterministické (pravidla), AI-ready — AI může položky doplňovat, ale komponenta na ní nezávisí."
      />
      <StateSection title="Plný stav s akcemi">
        <div className="rh-card">
          <AttentionList
            ariaLabel="Co hoří"
            severityLabels={severityLabels}
            items={demoAttention.map((a) => ({ ...a, action: { label: 'Vyřešit', onAction: () => {} } }))}
          />
        </div>
      </StateSection>
      <StateSection title="Prázdný stav" description="Nic nehoří je dobrá zpráva — a vlastní stav, ne díra v UI.">
        <div className="rh-card">
          <AttentionList
            ariaLabel="Co hoří"
            severityLabels={severityLabels}
            items={[]}
            emptyState={<EmptyState icon={<span>✅</span>} title="Nic nehoří" description="Všechny zálohy uhrazené, inzeráty aktivní, termíny drží." />}
          />
        </div>
      </StateSection>
    </div>
  );
}
